export default __webpack_public_path__ + "static/media/news9.b990abdb.mp4";